import styled from 'styled-components';

export const RecentSearchList = styled.div`
  display: grid;
  grid-template-columns: 30px 1fr 30px;
  grid-template-rows: 45px;
  align-items: center;
  padding: 0 18px;
  @media (min-width: 720px) {
    cursor: pointer;
  }
  svg {
    width: 18px !important;
    height: 18px !important;
    position: unset !important;
  }
`;

export const RecentListName = styled.span`
  font-size: 13px;
  color: rgb(0 0 0 / 40%);
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const HistroyArrow = styled.img`
  width: 18px;
  height: 18px;
`;
export const NorthEastArrow = styled.img`
  margin-left: auto;
  width: 18px;
  height: 18px;
`;
